import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks';

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  debugger;
  const { accessToken } = useAppSelector((state) => state.auth);

  // Check if we have a valid token, and if so, redirect to dashboard
  if (accessToken) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
